import { useFormik } from "formik";
import { useSelector } from "react-redux";
import FormDef from "../schema/model.json";
import addParentInfoDomain from "../domain";
import { useMemo } from "react";
import { NotificationManager } from "react-notifications";
import Config from "../../../../../../config";

const { OTHER_PROFESSION_ID } = Config;

const { buildInitialFormValues, buildFormValidationSchema, submitParentInfo } =
  addParentInfoDomain;

export const useAddParentModal = ({ closeModal, refreshAdData }) => {
  const { genericFilters } = useSelector((state) => state.genericDataV2);
  const { residentCountries, religions, ethnicities, professions } =
    genericFilters;

  const handleSubmitParentInfo = async (values, actions) => {
    try {
      const { postId } = values;
      const data = {...values};
      delete data["postId"];

      await submitParentInfo({ data, postId });
      if (
        typeof closeModal === "function" &&
        typeof refreshAdData === "function"
      ) {
        refreshAdData();
        closeModal();
      }
      actions.resetForm();
      NotificationManager.success("Parent information added");
    } catch (error) {
      NotificationManager.error("Unknown error occured");
    }
  };

  const formik = useFormik({
    initialValues: buildInitialFormValues(FormDef),
    validationSchema: buildFormValidationSchema(FormDef),
    onSubmit: handleSubmitParentInfo,
  });

  const {
    values,
    errors,
    handleChange,
    submitCount,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = formik;

  const isFieldVisible = (fieldName) => {
    switch (fieldName) {
      case FormDef.otherProfession.fieldName:
        return values[FormDef.professionId.fieldName] === OTHER_PROFESSION_ID;
      default:
        return true;
    }
  };

  const formatOptions = (items) =>
    items.map(({ id, name }) => ({
      label: name,
      value: id,
    }));

  const formattedEthnicities = useMemo(
    () => formatOptions(ethnicities),
    [ethnicities],
  );

  const formattedReligions = useMemo(
    () => formatOptions(religions),
    [religions],
  );

  const formattedResidentCountries = useMemo(
    () =>
      residentCountries.map(({ name, code }) => ({
        label: name,
        value: code,
      })),
    [residentCountries],
  );

  const formattedProfessions = useMemo(
    () => formatOptions(professions),
    [professions],
  );

  const handleFormSubmit = ({ parentType, postId }) => {
    setFieldValue("type", parentType);
    setFieldValue("postId", postId);
    handleSubmit();
  };

  return {
    FormDef,
    ethnicities: formattedEthnicities,
    religions: formattedReligions,
    residentCountries: formattedResidentCountries,
    professions: formattedProfessions,
    onchange: handleChange,
    values,
    errors: submitCount > 0 ? errors : {},
    handleFormSubmit,
    isFieldVisible,
    resetValues: resetForm,
  };
};
